module.exports = __webpack_public_path__ + "img/5d18c8d.png";